export default "__VITE_ASSET__BPnROCBT__"